import React from "react"
import { useTranslation } from "react-i18next"

import { ButtonERP, OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faLink } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { truncateString } from "common/utils/utils"
import { DEFAULT_CURRENCY_SYMBOL } from "features/Contactos/constants"
import {
  ImporteBodyTemplateTesoreria,
  warningBodyTemplate,
} from "features/Documentos/templates"
import { reverseBlockSplit } from "utils/reverseBlockSplit"
import { DEFAULT_BANK_LOGO_URL } from "../../constants"
import "../../style.scss"
import { getLastMovementDate } from "./constants"

const BankCard = ({
  data,
  onClick,
  menuItems,
  handleOpenModalAutorizar,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()

  const existRequisitionAndBalance = Boolean(
    data.balance && data.necesitaValidacion
  )

  return (
    <div className='tw-bg-simple-10 tw-rounded-lg tw-shadow tw-cursor-pointer tw-flex-col tw-flex tw-items-start tw-justify-between'>
      <div
        className={`tw-pt-5 tw-px-5 tw-w-full ${
          data?.saldos && !data?.necesitaValidacion ? "" : "tw-pb-4"
        }`}
      >
        <div className='tw-flex tw-justify-between tw-items-start'>
          <div
            className='tw-flex-col tw-gap-2'
            onClick={() => onClick(data)}
          >
            <p className='tw-mb-1 tw-text-start first-letter:tw-capitalize tw-lowercase tw-font-medium tw-text-sm tw-text-primary'>
              {data?.entidadBancaria?.nombre
                ? truncateString({
                    str: data?.entidadBancaria?.nombre,
                    maxLength: 24,
                  })
                : `${t("bancos.bankCard.noEntity")}`}
            </p>
            <p className='tw-text-sm'>{reverseBlockSplit(data.iban, 4)}</p>
          </div>
          <div className='tw-w-fit tw-flex tw-flex-row tw-items-center'>
            <div className='!tw-w-6 tw-flex tw-items-center tw-h-full tw-mr-2'>
              {warningBodyTemplate(data, t)}
            </div>
            <OptionsMenuStorybook
              id={data.id}
              items={menuItems}
              position='right'
            />
          </div>
        </div>
        <div
          className='tw-flex tw-justify-center'
          onClick={() => onClick(data)}
        >
          <img
            src={data.logo || DEFAULT_BANK_LOGO_URL}
            alt=''
            className={`tw-mt-6 tw-h-28 tw-p-2  ${
              data.logo ? "tw-scale-150" : ""
            }`}
          />
        </div>
        <div className='tw-flex tw-flex-col tw-mt-6 tw-w-full'>
          <p className='tw-text-sm tw-text-start'>
            {getLastMovementDate(data?.fechaUltimaActualizacion, t)}
          </p>
          <span className='tw-text-text tw-text-sm tw-font-medium tw-text-left tw-h-6 tw-truncate'>
            {data?.nombre}
          </span>
        </div>
      </div>
      <div
        className={`${
          data?.saldos && !data?.necesitaValidacion
            ? "tw-pb-5 tw-px-5"
            : "tw-border-t tw-border-solid tw-border-t-neutral-25 tw-py-2 tw-px-4"
        }   tw-w-full tw-flex tw-justify-center tw-items-center tw-h-fit ${
          existRequisitionAndBalance
            ? "tw-flex tw-justify-between tw-items-center"
            : ""
        }`}
      >
        {data?.saldos && !data?.necesitaValidacion && (
          <ImporteBodyTemplateTesoreria
            importe={data?.saldos?.disponible ?? 0}
            saldoActual={data?.saldos?.contable ?? 0}
            divisa={DEFAULT_CURRENCY_SYMBOL}
            className={`${
              data?.saldos?.disponible >= 0
                ? "!tw-text-success"
                : "!tw-text-danger"
            }`}
          />
        )}
        {data.necesitaValidacion ? (
          <ButtonERP
            customize={{
              size: "md",
              type: "primary",
            }}
            onClick={() => {
              data?.identificadorExterno && handleOpenModalAutorizar(data)
            }}
            className={`${
              !data?.identificadorExterno
                ? "!tw-opacity-20 !tw-cursor-not-allowed"
                : ""
            } !tw-w-full tw-justify-center tw-flex`}
            label={
              existRequisitionAndBalance
                ? `${t("bancos.bankCard.authorize")}`
                : `${t("bancos.bankCard.authorizeAccess")}`
            }
            icon={<FontAwesomeIcon icon={faLink} />}
            tooltip={
              !data?.identificadorExterno
                ? `${t("bancos.bankCard.externalIdDisabled")}`
                : undefined
            }
            tooltipOptions={{
              position: "mouse",
            }}
            unstyled
          />
        ) : null}
      </div>
    </div>
  )
}

export default React.memo(BankCard)
